<template>
    <div class="printManagementDialog">
        <el-dialog
            :title="title"
            :visible.sync="dialogVisible"
            width="800px">
            <div class="dialogBox">
                <div class="details">
                    <div class="detailsItem">
                        <h3>基础信息</h3>
                        <div class="itemContent">
                            <div class="two-row">
                                <div class="label">咨询分类:</div>
                                <div class="name">{{ form.consultName }}</div>
                            </div>
                            <div class="one-row">
                                <div class="label">联系人:</div>
                                <div class="name">{{ form.contactName }}</div>
                            </div>
                            <div class="one-row">
                                <div class="label">联系电话:</div>
                                <div class="name">{{ form.contactPhone }}</div>
                            </div>
                            <div class="two-row">
                                <div class="label">公司名称:</div>
                                <div class="name">{{ form.contactEnterprise }}</div>
                            </div>
                            <div class="one-row">
                                <div class="label">状态:</div>
                                <div class="name">{{ form.statusCn }}</div>
                            </div>
                            <div class="one-row">
                                <div class="label">处理日期:</div>
                                <div class="name">{{ form.modifyTime }}</div>
                            </div>
                            <div class="two-row" style="width:100%">
                                <div class="label">咨询内容:</div>
                                <div class="name">{{ form.content }}</div>
                            </div>
                            <div class="two-row">
                                <div class="label">处理内容:</div>
                                <div class="name">{{ form.resContent }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { findConsultInfo } from '../../utils/consultInfo';

    export default {
        name: "consultInfoDialog",
        data() {
            return {
                dialogVisible: false,
                title: '详情',
                form: {},
            }
        },
        methods: {
            init(deliveryTypeList,uuid) {
                this.dialogVisible = true;
                this.form = {};
                findConsultInfo(uuid).then((res)=>{
                    deliveryTypeList.map((delivery)=>{
                        if(res.data.consultUuid == delivery.uuid){
                            this.$set(res.data,'consultName',delivery.name)
                        }
                    })
                    this.form = res.data;
                });
            },
        }
    }
</script>

<style scoped lang="less">
  //审核查看详情中title的样式
/deep/.el-dialog__header{
    border-bottom: 1px solid #ddd;
   .el-dialog__title{
    color: #000;
    font-weight: 700;
    font-size: 16px;
    
  }
}
    .dialogBox{
        padding-top: 20px;
        .details{
            .detailsItem{
                padding-bottom: 20px;
                h3{
                    font-weight: 700;
                    font-size: 16px;
                    color: #000;
                    margin-top: 0;
                    letter-spacing: 1px;
                }
                .itemContent{
                    display: flex;
                    flex-wrap: wrap;
                    font-size: 15px;
                    // padding: 0 30px;
                    .one-row{
                        width: 50%;
                        margin-bottom: 22px;
                        display: flex;
                        font-size: 14px;
                        .label{
                            padding-right: 15px;
                            min-width: 110px;
                            color: rgba(0, 0, 0, 0.85);
                        }
                        .name{
                            // color: #000;
                            color: rgba(0, 0, 0, 0.65);
                        }
                    }
                    .two-row{
                        width: 50%;
                        margin-bottom: 22px;
                        display: flex;
                        font-size: 14px;
                        .label{
                            padding-right: 15px;
                            min-width: 110px;
                            color: rgba(0, 0, 0, 0.85);
                        }
                        .name{
                            // color: #000;
                            caret-color: rgba(0, 0, 0, 0.65);
                        }
                    }
                }
            }
            .area{
                span{
                    color: #3d7fff;
                    cursor: pointer;
                    &:hover{
                        text-decoration: underline;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/consultInfo/consultInfoDetail.vue